import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Sparkles, ChevronRight } from "lucide-react";

const fmt = (iso) => {
  try { return new Date(iso).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" }); }
  catch { return ""; }
};

// `free_until` and `after_pilot` are server-authoritative — rendered verbatim,
// never computed or paraphrased client-side.
export function PilotBanner({ pilot: pilotProp }) {
  const [pilot, setPilot] = useState(pilotProp ?? null);
  useEffect(() => {
    if (pilotProp !== undefined) { setPilot(pilotProp); return; }
    api.billingStatus().then((s) => setPilot(s?.pilot || null)).catch(() => {});
  }, [pilotProp]);

  if (!pilot) return null;
  return (
    <Link
      to="/app/billing"
      data-testid="pilot-banner"
      className="mt-5 flex items-start gap-3 bg-mint-tint border border-mint-dark rounded-xl p-4 hover:bg-mint-tint/70 transition-colors"
    >
      <div className="w-10 h-10 rounded-full bg-mint flex items-center justify-center shrink-0">
        <Sparkles className="w-5 h-5 text-brand-dark" />
      </div>
      <div className="flex-1">
        <div className="font-semibold text-ink" data-testid="pilot-banner-headline">
          Pilot — free until {fmt(pilot.free_until)}
        </div>
        <div className="text-sm text-subtle mt-0.5" data-testid="pilot-banner-after">{pilot.after_pilot}</div>
      </div>
      <ChevronRight className="w-5 h-5 text-subtle shrink-0" />
    </Link>
  );
}
